import { ORG_CREATED, ORGS_FETCHED } from 'actions';
import { SELECT_CURRENT_ORG } from 'actions';

const initState = {
}

export default function (state = initState, action) {
  switch (action.type) {

    case ORG_CREATED: {
      return {
        ...state,
        ...action.payload
      }
    }

    case ORGS_FETCHED: {
      const orgs = action.payload;
      const codeMap = orgs.reduce((result, item, index, array) => {
        const org = item.data();
        result[org.org_code] = { org_id: item.id, ...org };
        return result;
      }, {});
      return {
        ...state,
        orgs: action.payload,
        orgCodeMap: codeMap,
      }
    }

    case SELECT_CURRENT_ORG: {
      return {
        ...state,
        currentOrg: action.payload
      }
    }

    default:
      return state
  }
}